import { render, staticRenderFns } from "./dashboard-metrics.vue?vue&type=template&id=05052e9a&scoped=true&"
import script from "./dashboard-metrics.vue?vue&type=script&lang=js&"
export * from "./dashboard-metrics.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-metrics.vue?vue&type=style&index=0&id=05052e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05052e9a",
  null
  
)

export default component.exports